import { createRoot } from "react-dom/client";
import { ArchitectureLayers } from "./components/ArchitectureLayers";
import { CircuitBoard } from "./components/CircuitBoard";
import { DeliveryFlow } from "./components/DeliveryFlow";
import { EdgeGlobe } from "./components/EdgeGlobe";
import { WebVitals } from "./components/WebVitals";
import { ZeroTrustRings } from "./components/ZeroTrustRings";

type Island = () => React.ReactElement;

// Each server-rendered page leaves an empty <div data-island="…"> placeholder with a
// reserved size in CSS. We hydrate only those, so pages without a graph ship no extra work.
const REGISTRY: Record<string, Island> = {
  "edge-globe": EdgeGlobe,
  "circuit-board": CircuitBoard,
  "delivery-flow": DeliveryFlow,
  "zero-trust-rings": ZeroTrustRings,
  "web-vitals": WebVitals,
  "architecture-layers": ArchitectureLayers,
};

function mountIslands(): void {
  for (const node of document.querySelectorAll<HTMLElement>("[data-island]")) {
    if (node.dataset.islandMounted === "true") continue;
    const Component = REGISTRY[node.dataset.island ?? ""];
    if (!Component) continue;
    node.dataset.islandMounted = "true";
    createRoot(node).render(<Component />);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountIslands, { once: true });
} else {
  mountIslands();
}
